export const requiredList = ["用户名","密码","确认密码","手机号","验证码","用户协议"]
export const showList = ["用户名","密码","确认密码","手机号","验证码","用户协议"]